import React, {useEffect} from 'react'
import {getCommentByPiece} from '../../../../components/requests'

const ButtonActionPopper = (props) => {
  const {
    showCommentSection,
    piece,
    showCommentInput,
    setShowCommentSection,
    setCommentaireLoader,
    setCommentaires,
    handleWriteComment,
    handlePanier,
    index,
    fromSuggestionPage,
    setOpen,
    handleChangeStatutPropo,
  } = props

  // Ouverture & Fermeture Liste des commentaire par pièce
  const handleShowCommentOnSelectedPiece = (idPiece, btnShowState: boolean) => {
    if (btnShowState) {
      setShowCommentSection(true)
      getAllCommentByPieceProposee(idPiece)
    } else {
      setShowCommentSection(false)
    }
  }

  // Récupération des commentaire en fonction de la pièce proposée
  const getAllCommentByPieceProposee = (idPiece) => {
    setCommentaireLoader(true)
    getCommentByPiece(idPiece).then((res) => {
      if (res.data) {
        setCommentaireLoader(false)
        setCommentaires(res.data)
      }
    })
  }

  const handleCloseCommentaire = () => {
    // console.log('ici')
    setShowCommentSection(false)
    setOpen(false)
  }

  return (
    <>
      <div className={'d-flex gap-2 w-100 justify-content-between align-items-center'}>
        {showCommentSection && <span className={'h6 mb-0 p-3'}>Commentaire de la pièce</span>}
        {fromSuggestionPage ? (
          showCommentSection && (
            <button
              className={'btn btn-icon btn-bg-light btn-sm'}
              onClick={() => handleCloseCommentaire()}
            >
              <i className='ki-duotone ki-cross fs-2'>
                <span className='path1'></span>
                <span className='path2'></span>
              </i>
            </button>
          )
        ) : (
          <>
            <div className={'d-flex gap-3'}>
              {/*Bouton ouverture & fermeture commentaire*/}
              <button
                className={
                  'btn btn-icon btn-bg-light btn-sm bg-hover-light-primary text-hover-primary'
                }
                onClick={() =>
                  handleShowCommentOnSelectedPiece(
                    piece.idPiecePropose,
                    !showCommentSection // toggle
                  )
                }
                data-tooltip-id='panier-actions'
                data-tooltip-content={`${
                  showCommentSection ? 'Fermer commentaire(s)' : 'Ouvrir commentaire(s)'
                }`}
                data-tooltip-place='top'
              >
                {showCommentSection ? (
                  <i className='ki-duotone ki-cross fs-2'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                ) : (
                  <i className='ki-duotone ki-message-text fs-2'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                  </i>
                )}
              </button>

              {/*Bouton ouverture & fermeture input de commentaire*/}
              {!showCommentSection && (piece?.statut === 'A_PROPO' || piece?.statut === 'PROPO') && (
                <button
                  className={`btn btn-icon btn-bg-light btn-sm ${
                    showCommentInput === index
                      ? 'bg-hover-light-danger text-hover-danger'
                      : 'bg-hover-light-info text-hover-info'
                  }`}
                  onClick={() => handleWriteComment(piece?.idPiecePropose)}
                  data-tooltip-id='panier-actions'
                  data-tooltip-content={`${
                    showCommentInput ? 'Fermer champ' : 'Saisir un commentaire'
                  }`}
                  data-tooltip-place='top'
                >
                  {showCommentInput === index ? (
                    <i className='ki-duotone ki-cross fs-2'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  ) : (
                    <i className='bi bi-cursor-text'></i>
                  )}
                </button>
              )}
            </div>

            {/*Bouton qui change le statut en à proposee pour une pièce refuser */}
            {piece?.statut === 'REFUS' && (
                <button
                    className={
                      'btn btn-icon btn-bg-light btn-sm bg-hover-light-primary text-hover-primary'
                    }
                >
                  <img
                      src='/media/svg/custom/reload.svg'
                      width='18'
                      onClick={() =>
                          handleChangeStatutPropo(piece?.idPiecePropose)
                      }
                      style={{
                        cursor: 'pointer',
                        opacity: 1,
                      }}
                      alt='Statut à proposer'
                      data-tooltip-id='statut-propose-actions'
                      data-tooltip-content={'Changer le statut en "à proposer"'}
                      data-tooltip-place='top'
                  />
                </button>
            )}

            {/*Bouton suppression de pièce dans le panier*/}
            {piece?.statut === 'A_PROPO' && !showCommentSection && (
              <button
                className={
                  'btn btn-icon btn-bg-light btn-sm bg-hover-light-danger text-hover-danger'
                }
              >
                <img
                  src='/media/svg/custom/bag-minus.svg'
                  width='18'
                  onClick={() =>
                    piece?.statut === 'A_PROPO' && handlePanier(piece.id, piece?.idPiecePropose)
                  }
                  style={{
                    cursor: piece?.statut === 'A_PROPO' ? 'pointer' : 'default',
                    opacity: piece?.statut === 'A_PROPO' ? 1 : 0,
                  }}
                  alt='Supprimer'
                  data-tooltip-id='panier-actions'
                  data-tooltip-content={'Supprimer la pièce'}
                  data-tooltip-place='top'
                />
              </button>
            )}
          </>
        )}
      </div>
    </>
  )
}

export default ButtonActionPopper